export default "__VITE_ASSET__PePZtWuE__"